import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './detail.css';
import Sidebar from '../../components/SideBar/Sidebar.js';
import { GetTimeZone, formatDate } from '../../components/common/DateTimeFormatter';
//import { useParams } from 'react-router-dom';
import { hideLoading, showLoading } from '../../store/loading-reducer';
import PropTypes from 'prop-types';
import { shopMonitorSliderTime } from '../../helpers/enums';
import ProfileImage from '../../assets/profile-lg.png';
import { getEmployeeList } from '../../store/employee/actions';
export default function ShopWelcome({ handleloadinTiming }) {
    const dispatch = useDispatch();
    //const { fetchNext } = useParams(); 
    const { employeeList } = useSelector(state => state.employee);
    const [filter] = useState({ query: '', companyId: 0, sort: 12, timezone: GetTimeZone() });
    const isLoading = useSelector((state) => state.loading);
    const [isDataLoaded, setIsDataLoaded] = useState(false);


    useEffect(() => {
        document.title = 'Welcome | CWP Team Connect';
        dispatch(showLoading());
        handleloadinTiming(shopMonitorSliderTime.LeadingTime);
        let sharpCompanyId = localStorage.getItem('monitor_mode_company');
        filter.companyId = (sharpCompanyId != null && sharpCompanyId !== undefined) ? parseInt(sharpCompanyId) : 0;
        dispatch(getEmployeeList(filter)).unwrap().then(() => {
            dispatch(hideLoading());
            handleloadinTiming(shopMonitorSliderTime.default);
            setIsDataLoaded(true);
        });
    }, []);


    useEffect(() => {
        if (isLoading && isDataLoaded) {
            dispatch(hideLoading());
            handleloadinTiming(shopMonitorSliderTime.default);
        }
    }, [isLoading, isDataLoaded]);


    return (
        <div className="monitors-inner">
            <div className="monitors-item">
                <div className="monitors-header-wrap">
                    <p className="monitors-header-title">Welcome new team members!</p>
                </div>
                <div className="monitors-item-event-wrap">

                    {/*<div className="monitors-item-event-item">*/}
                    {/*	<div className="monitors-item-event-full">*/}
                    {/*		<span className="news-description">No Tours or Visitors Today</span>*/}
                    {/*	</div>*/}
                    {/*</div>*/}

                    <div className="monitors-item-event-wrap">
                        <div className="monitors-item-event-item">
                            <div className="monitors-item-event-item-inner">
                                <div className="welcome-item-wrap">
                                    {employeeList && employeeList.length > 0 && (() => {
                                        const totalItems = Math.min(employeeList.length, 8); // Limit to 8 items
                                        let additionalClass = "";

                                        if (totalItems >= 4) {
                                            additionalClass = "welcome-items-multiple";
                                        }
                                        if (totalItems >= 5 && totalItems <= 6) {
                                            additionalClass += " welcome-md"; // Append welcome-md for 5-6 items
                                        }

                                        return (
                                            <div className={`welcome-items-container ${additionalClass.trim()}`}>
                                                {employeeList
                                                    .slice(0, 8)
                                                    .sort((a, b) => (a?.primaryCompanyId || 0) - (b?.primaryCompanyId || 0))
                                                    .map((employee, index) => (
                                                        <div className="welcome-item" key={employee.id || index}>
                                                            <div className="monitors-people-img-wrap">
                                                                <img src={employee?.profileImage?.previewsrc ? employee.profileImage.previewsrc : ProfileImage} alt="placeholder image" />
                                                            </div>
                                                            <div className="welcome-item-info">
                                                                <p className="welcome-title">{employee?.fullName}</p>
                                                                <p className="welcome-desc">{employee?.departmentDisplay}</p>
                                                                <p className="welcome-date">{employee?.startDate && formatDate(employee?.startDate, "EEEE, MMMM d")}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        );
                                    })()}


                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <Sidebar pageType={"welcome"} />
        </div>
    );
}

ShopWelcome.propTypes = {
    handleloadinTiming: PropTypes.func
};